import m from 'mithril';

import client from '@shared/utils/client-rest';
import { LIST_HEAT_METRICS, LIST_HEAT_METRICS_LABEL } from '@shared/constants';
import NotifyModel from '@app/models/notify';

class HeatMetrics {
    constructor() {
        this.loading = false;
        this.submitting = false;
        this.data = null;
        this.id = null;
        this.metric_keys = null;
    }

    fetch = (customer_id) => {
        this.loading = true;
        return client(`/api/v1/pages/heatmap-settings`, {
            params: { customer_id },
        }).then((res) => {
            const result = [];
            const metric_keys = res?.metric_keys || [];

            LIST_HEAT_METRICS?.map((metric) => {
                if (metric_keys?.find((i) => i === metric)) {
                    return result.push({ metric_key: metric, enable: true, label: LIST_HEAT_METRICS_LABEL[metric] });
                }
                return result.push({ metric_key: metric, enable: false, label: LIST_HEAT_METRICS_LABEL[metric] });
            });

            this.metric_keys = metric_keys;
            this.id = res?.id || null;
            this.data = result;
            this.loading = false;
        });
    };

    submit = async (customer_id) => {
        this.submitting = true;
        const metric_keys = this.data.filter((i) => i.enable).map((i) => i.metric_key);
        if (this.id) {
            return await client(`/api/v1/pages/heatmap-settings/${this.id}`, {
                method: 'PUT',
                body: { metric_keys, customer_id },
            })
                .then((res) => {
                    NotifyModel.showNotify(`Update heat metrics success`);
                    this.id = res.id;
                })
                .finally(() => (this.submitting = false));
        }

        return await client(`/api/v1/pages/heatmap-settings`, {
            method: 'POST',
            body: { metric_keys, customer_id },
        })
            .then((res) => {
                NotifyModel.showNotify(`Update heat metrics success`);
                this.id = res.id;
            })
            .finally(() => (this.submitting = false));
    };

    reset = () => {
        this.loading = false;
        this.submitting = false;
        this.data = null;
        this.id = null;
    };
}

export default new HeatMetrics();
